import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './Unsubscribe.css';

function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Pre-fill email from URL param if provided (e.g., ?email=user@example.com)
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const reasons = [
    { value: '', label: 'Select a reason (optional)' },
    { value: 'too_many', label: 'Too many emails' },
    { value: 'not_interested', label: 'Not interested' },
    { value: 'already_subscribed', label: 'Already subscribed elsewhere' },
    { value: 'not_relevant', label: 'Content not relevant' },
    { value: 'other', label: 'Other' },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Please provide a valid email address.');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        'https://lionfish-app-w73zu.ondigitalocean.app/api/unsubscribe/',
        { email: email.trim().toLowerCase(), reason }
      );

      if (response.data.success) {
        navigate('/unsubscribe/success');
      } else if (response.data.already_unsubscribed) {
        setError(`${email} is already unsubscribed.`);
      } else {
        setError(response.data.message || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="unsubscribe-container">
      <div className="unsubscribe-card">
        <h1>Unsubscribe from Emails</h1>
        <p className="unsubscribe-description">
          Enter your email address below to unsubscribe from our marketing emails.
        </p>

        {error && <div className="unsubscribe-error">{error}</div>}

        <form onSubmit={handleSubmit} className="unsubscribe-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="reason">Reason for unsubscribing</label>
            <select
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            >
              {reasons.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="unsubscribe-button" disabled={loading}>
            {loading ? 'Unsubscribing...' : 'Unsubscribe'}
          </button>
        </form>

        <p className="unsubscribe-note">
          This will only unsubscribe you from marketing emails. You may still receive
          important account-related emails.
        </p>
      </div>
    </div>
  );
}

export default Unsubscribe;